import { useState, useEffect, useCallback } from 'react';
import { useOnlineStatus } from './useOnlineStatus';
import * as offlineQueue from '@/lib/offlineQueue';
import { onSyncStateChange, isSyncing as getSyncState } from '@/lib/syncManager';

export function useOfflineQueue() {
  const { isOnline } = useOnlineStatus();
  const [pendingCount, setPendingCount] = useState(0);
  const [isSyncing, setIsSyncing] = useState(getSyncState);

  const refreshCount = useCallback(() => {
    void offlineQueue.size().then(setPendingCount);
  }, []);

  useEffect(() => {
    // Initial count
    refreshCount();

    // Subscribe to queue changes
    const unsubQueue = offlineQueue.subscribe(refreshCount);

    // Subscribe to sync-state changes
    const unsubSync = onSyncStateChange(setIsSyncing);

    return () => {
      unsubQueue();
      unsubSync();
    };
  }, [refreshCount]);

  return { pendingCount, isOnline, isSyncing };
}
